// CoreUI Pro source reference: /Users/guochunzhong/git/oss/coreui-pro/js/src/rating.js
import BaseComponent from "./base_component"
import { parseList } from "./dom"
let generatedId = 0

export default class Rating extends BaseComponent {
  static componentName = "rating"
  static defaults = {
    allowClear: false,
    disabled: false,
    itemCount: 5,
    precision: 1,
    readOnly: false,
    tooltips: false,
    value: null,
  }

  constructor(element, config = {}) {
    super(element, config)
    this.value = this.config.value === null ? null : Number(this.config.value)
    this.name = this.config.name || `rating-${++generatedId}`
    this.render()
    this.listen(element, "change", (event) => {
      if (event.target.matches(".rating-item-input")) this.select(Number(event.target.value))
    })
  }

  render() {
    this.element.replaceChildren()
    this.element.className = this.originalClassName
    this.element.classList.add("rating")
    if (this.config.size) this.element.classList.add(`rating-${this.config.size}`)
    if (this.config.disabled) this.element.classList.add("disabled")
    if (this.config.readOnly) this.element.classList.add("readonly")
    this.element.setAttribute("role", "radiogroup")
    const precision = Number(this.config.precision)
    for (let item = 0; item < Number(this.config.itemCount); item += 1) {
      const wrapper = document.createElement("div")
      wrapper.className = "rating-item"
      for (let fraction = 1; fraction <= 1 / precision; fraction += 1) {
        const value = item + fraction * precision
        const id = `rating-${++generatedId}`
        const label = document.createElement("label")
        label.className = `rating-item-label${this.value >= value ? " active" : ""}`
        label.htmlFor = id
        if (precision < 1 && fraction < 1 / precision)
          Object.assign(label.style, {
            position: "absolute",
            width: `${fraction * precision * 100}%`,
            overflow: "hidden",
            zIndex: 1 / precision - fraction + 1,
          })
        label.innerHTML = '<div class="rating-item-icon"></div>'
        const input = document.createElement("input")
        input.className = "rating-item-input"
        input.id = id
        input.type = "radio"
        input.name = this.name
        input.value = value
        input.checked = this.value === value
        input.disabled = Boolean(this.config.disabled || this.config.readOnly)
        input.setAttribute(
          "aria-label",
          this.config.ariaLabel
            ? this.config.ariaLabel(value, this.config.itemCount)
            : `${value} of ${this.config.itemCount}`,
        )
        const tooltip =
          this.config.tooltips === true ? String(value) : parseList(this.config.tooltips)[Math.ceil(value) - 1]
        if (tooltip) label.title = tooltip
        wrapper.append(label, input)
      }
      this.element.append(wrapper)
    }
  }

  select(value) {
    if (this.config.disabled || this.config.readOnly) return
    this.value = this.config.allowClear && this.value === value ? null : value
    this.element.querySelectorAll(".rating-item-input").forEach((input) => {
      input.checked = Number(input.value) === this.value
      input.previousElementSibling.classList.toggle("active", this.value >= Number(input.value))
    })
    this.emit("change", { value: this.value })
  }

  dispose() {
    if (this.signal.aborted) return
    this.element.innerHTML = this.originalHTML
    this.element.className = this.originalClassName
    super.dispose()
  }
  snapshotState() {
    return { config: { value: this.value } }
  }
}
